export const randomNumber = numOfDigits => {
    return Math.floor(Math.random() * 9 * Math.pow(10, (numOfDigits - 1)) + Math.pow(10, (numOfDigits - 1)));
};

export const randomHexColor = () => {
    return '#' + Math.random().toString(16).slice(2, 8).toUpperCase().replace(/[^0-9a-f]/gi, '');
};